import React from 'react'
import { Link } from 'react-router-dom'

import { Breadcrumb, Menu } from 'antd'
import { LayoutContentWrapper } from './layoutWrapper.style'

const renderBreadCrumb = (props) => {
    if (!props.breadcrumbs) {
        return null
    }
    const breadcrumbsDom = props.breadcrumbs.map((breadcrumb, index) => {
        // A breadcrumb item may carry a `menu` array of { path, name } to render
        // as an antd dropdown (caret + overlay) — used e.g. when a customer
        // belongs to several companies. The label still links to `path`.
        const label = breadcrumb.path
            ? <Link to={breadcrumb.path}>{breadcrumb.name}</Link>
            : breadcrumb.name

        if (breadcrumb.menu && breadcrumb.menu.length) {
            const overlay = (
                <Menu>
                    {breadcrumb.menu.map((item) => (
                        <Menu.Item key={item.path}>
                            <Link to={item.path}>{item.name}</Link>
                        </Menu.Item>
                    ))}
                </Menu>
            )
            return (
                <Breadcrumb.Item key={index} overlay={overlay}>
                    {label}
                </Breadcrumb.Item>
            )
        }

        return (
            <Breadcrumb.Item key={index}>
                {label}
            </Breadcrumb.Item>
        )
    })
    return (
        <Breadcrumb className="breadcrumbContentWrapper">
            <Breadcrumb.Item>
                <Link to={`/`}>
                    Home
                </Link>
            </Breadcrumb.Item>
            { breadcrumbsDom }
        </Breadcrumb>
    )
}

export default props => (
    <LayoutContentWrapper
        className={
            props.className != null ?
                `${props.className} isoLayoutContentWrapper` :
                'isoLayoutContentWrapper'
        }
        {...props}
    >
        {renderBreadCrumb(props)}
        {props.children}
    </LayoutContentWrapper>
)
